module.exports = "pegasus/assets/blocks/column-16-theme6.png";